module.exports = __webpack_public_path__ + "static/media/ddx-placeHolder.4d181723.png";